import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { A as Autoplay } from './embla-carousel-autoplay.esm-BukruCx2.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

class HeroBanner extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  #autoplayDelay = parseInt(this.dataset.autoplay);
  #section = this.closest('.shopify-section--hero-banner');
  #slides = this.#section.querySelectorAll('.embla__slide');
  #height = 0;
  #raf = 0;
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => this.#init(),
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    cancelAnimationFrame(this.#raf);
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onResize);
    this.#embla?.destroy();
    this.#embla = undefined;
  }

  #init() {
    // Single-slide heroes omit .embla__viewport — skip Embla, still enable sticky clip
    const viewport = this.querySelector('.embla__viewport');
    if (viewport && this.#slides.length > 1) {
      this.#embla = EmblaCarousel(
        viewport,
        {
          loop: true,
          align: 'start',
          direction: document.dir,
          active: true,
        },
        this.#autoplayDelay ? [Autoplay({ delay: this.#autoplayDelay })] : []
      );
    }

    if (!this.hasAttribute('data-sticky-hero')) return;

    // Cache height once — scroll handler only reads scrollY (no layout reads)
    this.#height = this.#section.offsetHeight;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onResize, { passive: true });
    this.#onScroll();
  }

  #onResize = () => {
    this.#height = this.#section.offsetHeight;
  };

  #onScroll = () => {
    // Coalesce style writes to one per frame — avoid scroll→layout thrashing
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = 0;
      const clip = Math.max(0, Math.min(this.#height, window.scrollY));
      this.#section.style.setProperty('--clip-bottom', `${clip}px`);
    });
  };
}

customElements.define('hero-banner', HeroBanner);
